import React from "react";
import "./apps/timely/installPrompt";
import ReactDOM from "react-dom/client";
import AppSelector from "./apps/AppSelector";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import client from "./platform/config/client";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { ThemeProviderComponent } from "./platform/assets/css/themeContext";
import { persistor, store } from "./platform/redux/store";
import { ConfirmProvider } from "material-ui-confirm";
// import { Helmet } from "react-helmet";
// import Logo from "./platform/assets/images/plany365.ico";

// GlobalSEO Component sets static SEO meta tags that are common for your app.
// For dynamic pages, consider rendering SEO meta tags in each relevant component.
// const GlobalSEO = () => (
//   <Helmet>
//     {/* Basic Meta Tags */}
//     <title>Plany365 - Free Online Appointment Scheduling Software</title>
//     <meta
//       name="description"
//       content="Discover the ideal events, services, classes, or businesses with Plany365. Our free scheduling software makes it effortless to manage appointments while connecting you to the best opportunities that suit your lifestyle."
//     />
//     <meta
//       name="keywords"
//       content="appointment scheduling, online booking, free scheduling, events, services, classes, businesses, Plany365"
//     />
//     <meta name="robots" content="index, follow" />
//     <link rel="canonical" href="https://plany365.com" />

//     {/* Open Graph Meta Tags */}
//     <meta property="og:type" content="website" />
//     <meta property="og:url" content="https://plany365.com" />
//     <meta
//       property="og:title"
//       content="Plany365 - Free Online Appointment Scheduling Software"
//     />
//     <meta
//       property="og:description"
//       content="Discover the ideal events, services, classes, or businesses with Plany365. Our platform simplifies appointment management and helps you connect with opportunities that match your needs."
//     />
//     {/* Specify your custom preview image here */}
//     <meta
//       property="og:image"
//       content={Logo}
//     />

//     {/* Twitter Card Meta Tags */}
//     <meta name="twitter:card" content="summary_large_image" />
//     <meta
//       name="twitter:image"
//       content={Logo}
//     />

//     {/* JSON-LD Structured Data for better understanding by search engines */}
//     <script type="application/ld+json">{`
//       {
//         "@context": "https://schema.org",
//         "@type": "WebSite",
//         "url": "https://plany365.com",
//         "name": "Plany365",
//         "description": "Discover the ideal events, services, classes, or businesses with Plany365. Our free online scheduling software makes appointment management effortless and connects you with the opportunities that matter most."
//       }
//     `}</script>
//   </Helmet>
// );

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_SIGN_IN_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <React.StrictMode>
          <ThemeProviderComponent>
            <Provider store={store}>
              <PersistGate loading={null} persistor={persistor}>
                <ConfirmProvider>
                  {/* Global SEO integration added before rendering the main App */}
                  {/* <GlobalSEO /> */}
                  <AppSelector />
                </ConfirmProvider>
              </PersistGate>
            </Provider>
          </ThemeProviderComponent>
        </React.StrictMode>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </ApolloProvider>
);

// Start measuring performance if needed
reportWebVitals();
